// Generated from /builds/tableau-expression/tableau-expression-parser-js/build/nerv-resources/resources/TableauExpression.g4 by ANTLR 4.7.2
// jshint ignore: start
var antlr4 = require('antlr4/index');



var serializedATN = ["\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964",
    "\u00024\u0203\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004",
    "\u0004\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t",
    "\u0007\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004",
    "\f\t\f\u0004\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010",
    "\t\u0010\u0004\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013",
    "\u0004\u0014\t\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017",
    "\t\u0017\u0004\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a",
    "\u0004\u001b\t\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e",
    "\t\u001e\u0004\u001f\t\u001f\u0004 \t \u0004!\t!\u0004\"\t\"\u0004#",
    "\t#\u0004$\t$\u0004%\t%\u0004&\t&\u0004\'\t\'\u0004(\t(\u0004)\t)\u0004",
    "*\t*\u0004+\t+\u0004,\t,\u0004-\t-\u0004.\t.\u0004/\t/\u00040\t0\u0004",
    "1\t1\u00042\t2\u00043\t3\u00044\t4\u00045\t5\u00046\t6\u00047\t7\u0004",
    "8\t8\u00049\t9\u0004:\t:\u0004;\t;\u0004<\t<\u0004=\t=\u0004>\t>\u0004",
    "?\t?\u0004@\t@\u0004A\tA\u0004B\tB\u0004C\tC\u0004D\tD\u0004E\tE\u0004",
    "F\tF\u0004G\tG\u0004H\tH\u0004I\tI\u0004J\tJ\u0004K\tK\u0004L\tL\u0004",
    "M\tM\u0004N\tN\u0004O\tO\u0004P\tP\u0004Q\tQ\u0004R\tR\u0004S\tS\u0004",
    "T\tT\u0004U\tU\u0004V\tV\u0004W\tW\u0003\u0002\u0003\u0002\u0003\u0003",
    "\u0003\u0003\u0003\u0004\u0003\u0004\u0003\u0005\u0003\u0005\u0003\u0006",
    "\u0003\u0006\u0003\u0007\u0003\u0007\u0003\b\u0003\b\u0003\t\u0003\t",
    "\u0003\n\u0003\n\u0003\u000b\u0003\u000b\u0003\f\u0003\f\u0003\r\u0003",
    "\r\u0003\u000e\u0003\u000e\u0003\u000f\u0003\u000f\u0003\u0010\u0003",
    "\u0010\u0003\u0011\u0003\u0011\u0003\u0012\u0003\u0012\u0003\u0013\u0003",
    "\u0013\u0003\u0014\u0003\u0014\u0003\u0015\u0003\u0015\u0003\u0016\u0003",
    "\u0016\u0003\u0017\u0003\u0017\u0003\u0018\u0003\u0018\u0003\u0019\u0003",
    "\u0019\u0003\u001a\u0003\u001a\u0003\u001b\u0003\u001b\u0003\u001c\u0003",
    "\u001c\u0003\u001c\u0003\u001d\u0003\u001d\u0003\u001d\u0003\u001d\u0003",
    "\u001d\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003",
    "\u001f\u0003\u001f\u0003\u001f\u0003\u001f\u0003\u001f\u0003\u001f\u0003",
    "\u001f\u0003 \u0003 \u0003 \u0003 \u0003!\u0003!\u0003!\u0003!\u0003",
    "!\u0003\"\u0003\"\u0003\"\u0003\"\u0003\"\u0003#\u0003#\u0003#\u0003",
    "#\u0003#\u0003$\u0003$\u0003$\u0003$\u0003$\u0003$\u0003%\u0003%\u0003",
    "%\u0003%\u0003%\u0003&\u0003&\u0003&\u0003&\u0003\'\u0003\'\u0003\'",
    "\u0003(\u0003(\u0003(\u0003(\u0003)\u0003)\u0003)\u0003)\u0003*\u0003",
    "*\u0003*\u0003*\u0003*\u0003+\u0003+\u0003+\u0003+\u0003+\u0003+\u0003",
    "+\u0003+\u0003,\u0003,\u0003,\u0003,\u0003,\u0003,\u0003,\u0003,\u0003",
    ",\u0003,\u0003-\u0003-\u0003-\u0003-\u0003-\u0003-\u0003.\u0003.\u0003",
    ".\u0003.\u0003.\u0003.\u0003.\u0003.\u0003/\u0003/\u0003/\u0003/\u0003",
    "/\u0003/\u0003/\u0003/\u00030\u00030\u00030\u00030\u00070\u0156\n0\f",
    "0\u000e0\u0159\u000b0\u00031\u00031\u00032\u00032\u00032\u00072\u0160",
    "\n2\f2\u000e2\u0163\u000b2\u00033\u00033\u00033\u00073\u0168\n3\f3\u000e",
    "3\u016b\u000b3\u00034\u00034\u00034\u00034\u00035\u00035\u00035\u0003",
    "6\u00036\u00036\u00076\u0177\n6\f6\u000e6\u017a\u000b6\u00037\u0003",
    "7\u00037\u00077\u017f\n7\f7\u000e7\u0182\u000b7\u00038\u00038\u0003",
    "8\u00038\u00039\u00039\u00039\u00039\u0003:\u0003:\u0005:\u018e\n:\u0003",
    ";\u0003;\u0003;\u0003<\u0003<\u0003<\u0003=\u0003=\u0005=\u0198\n=\u0003",
    ">\u0007>\u019b\n>\f>\u000e>\u019e\u000b>\u0003?\u0003?\u0003?\u0003",
    "?\u0003@\u0003@\u0003@\u0003A\u0003A\u0003B\u0006B\u01aa\nB\rB\u000e",
    "B\u01ab\u0003B\u0003B\u0006B\u01b0\nB\rB\u000eB\u01b1\u0005B\u01b4\n",
    "B\u0003C\u0007C\u01b7\nC\fC\u000eC\u01ba\u000bC\u0003C\u0003C\u0006",
    "C\u01be\nC\rC\u000eC\u01bf\u0003C\u0003C\u0003C\u0005C\u01c5\nC\u0003",
    "C\u0006C\u01c8\nC\rC\u000eC\u01c9\u0005C\u01cc\nC\u0003D\u0003D\u0003",
    "E\u0003E\u0003F\u0003F\u0003G\u0003G\u0003H\u0003H\u0003I\u0003I\u0003",
    "J\u0003J\u0003K\u0003K\u0003L\u0003L\u0003M\u0003M\u0003N\u0003N\u0003",
    "O\u0003O\u0003P\u0003P\u0003Q\u0003Q\u0003R\u0003R\u0003S\u0003S\u0003",
    "S\u0003T\u0003T\u0003T\u0003U\u0003U\u0003U\u0005U\u01f5\nU\u0003V\u0003",
    "V\u0003V\u0003V\u0005V\u01fb\nV\u0003W\u0006W\u01fe\nW\rW\u000eW\u01ff",
    "\u0003W\u0003W\u0002\u0002X\u0003\u0002\u0005\u0002\u0007\u0002\t\u0002",
    "\u000b\u0002\r\u0002\u000f\u0002\u0011\u0002\u0013\u0002\u0015\u0002",
    "\u0017\u0002\u0019\u0002\u001b\u0002\u001d\u0002\u001f\u0002!\u0002",
    "#\u0002%\u0002\'\u0002)\u0002+\u0002-\u0002/\u00021\u00023\u00025\u0002",
    "7\u00039\u0004;\u0005=\u0006?\u0007A\bC\tE\nG\u000bI\fK\rM\u000eO\u000f",
    "Q\u0010S\u0011U\u0012W\u0013Y\u0014[\u0015]\u0016_\u0017a\u0002c\u0018",
    "e\u0002g\u0019i\u001ak\u0002m\u0002o\u0002q\u0002s\u001bu\u0002w\u0002",
    "y\u001c{\u0002}\u001d\u007f\u001e\u0081\u0002\u0083\u001f\u0085 \u0087",
    "!\u0089\"\u008b#\u008d$\u008f%\u0091&\u0093\'\u0095(\u0097)\u0099*\u009b",
    "+\u009d,\u009f-\u00a1.\u00a3/\u00a50\u00a71\u00a92\u00ab3\u00ad4\u0003",
    "\u0002#\u0004\u0002CCcc\u0004\u0002DDdd\u0004\u0002EEee\u0004\u0002",
    "FFff\u0004\u0002GGgg\u0004\u0002HHhh\u0004\u0002IIii\u0004\u0002JJj",
    "j\u0004\u0002KKkk\u0004\u0002LLll\u0004\u0002MMmm\u0004\u0002NNnn\u0004",
    "\u0002OOoo\u0004\u0002PPpp\u0004\u0002QQqq\u0004\u0002RRrr\u0004\u0002",
    "SSss\u0004\u0002TTtt\u0004\u0002UUuu\u0004\u0002VVvv\u0004\u0002WWw",
    "w\u0004\u0002XXxx\u0004\u0002YYyy\u0004\u0002ZZzz\u0004\u0002[[{{\u0004",
    "\u0002\\\\||\u0004\u0002\f\f\u000f\u000f\u0006\u0002C\\aac|\u0082\u0000",
    "\u0003\u0002__\u0003\u0002$$\u0003\u0002))\u0006\u0002\f\f\u000f\u000f",
    "$%))\u0005\u0002\u000b\f\u000f\u000f\"\"\u0002\u01f6\u00027\u0003\u0002",
    "\u0002\u0002\u00029\u0003\u0002\u0002\u0002\u0002;\u0003\u0002\u0002",
    "\u0002\u0002=\u0003\u0002\u0002\u0002\u0002?\u0003\u0002\u0002\u0002",
    "\u0002A\u0003\u0002\u0002\u0002\u0002C\u0003\u0002\u0002\u0002\u0002",
    "E\u0003\u0002\u0002\u0002\u0002G\u0003\u0002\u0002\u0002\u0002I\u0003",
    "\u0002\u0002\u0002\u0002K\u0003\u0002\u0002\u0002\u0002M\u0003\u0002",
    "\u0002\u0002\u0002O\u0003\u0002\u0002\u0002\u0002Q\u0003\u0002\u0002",
    "\u0002\u0002S\u0003\u0002\u0002\u0002\u0002U\u0003\u0002\u0002\u0002",
    "\u0002W\u0003\u0002\u0002\u0002\u0002Y\u0003\u0002\u0002\u0002\u0002",
    "[\u0003\u0002\u0002\u0002\u0002]\u0003\u0002\u0002\u0002\u0002_\u0003",
    "\u0002\u0002\u0002\u0002c\u0003\u0002\u0002\u0002\u0002g\u0003\u0002",
    "\u0002\u0002\u0002i\u0003\u0002\u0002\u0002\u0002s\u0003\u0002\u0002",
    "\u0002\u0002y\u0003\u0002\u0002\u0002\u0002}\u0003\u0002\u0002\u0002",
    "\u0002\u007f\u0003\u0002\u0002\u0002\u0002\u0083\u0003\u0002\u0002\u0002",
    "\u0002\u0085\u0003\u0002\u0002\u0002\u0002\u0087\u0003\u0002\u0002\u0002",
    "\u0002\u0089\u0003\u0002\u0002\u0002\u0002\u008b\u0003\u0002\u0002\u0002",
    "\u0002\u008d\u0003\u0002\u0002\u0002\u0002\u008f\u0003\u0002\u0002\u0002",
    "\u0002\u0091\u0003\u0002\u0002\u0002\u0002\u0093\u0003\u0002\u0002\u0002",
    "\u0002\u0095\u0003\u0002\u0002\u0002\u0002\u0097\u0003\u0002\u0002\u0002",
    "\u0002\u0099\u0003\u0002\u0002\u0002\u0002\u009b\u0003\u0002\u0002\u0002",
    "\u0002\u009d\u0003\u0002\u0002\u0002\u0002\u009f\u0003\u0002\u0002\u0002",
    "\u0002\u00a1\u0003\u0002\u0002\u0002\u0002\u00a3\u0003\u0002\u0002\u0002",
    "\u0002\u00a5\u0003\u0002\u0002\u0002\u0002\u00a7\u0003\u0002\u0002\u0002",
    "\u0002\u00a9\u0003\u0002\u0002\u0002\u0002\u00ab\u0003\u0002\u0002\u0002",
    "\u0002\u00ad\u0003\u0002\u0002\u0002\u0003\u00af\u0003\u0002\u0002\u0002",
    "\u0005\u00b1\u0003\u0002\u0002\u0002\u0007\u00b3\u0003\u0002\u0002\u0002",
    "\t\u00b5\u0003\u0002\u0002\u0002\u000b\u00b7\u0003\u0002\u0002\u0002",
    "\r\u00b9\u0003\u0002\u0002\u0002\u000f\u00bb\u0003\u0002\u0002\u0002",
    "\u0011\u00bd\u0003\u0002\u0002\u0002\u0013\u00bf\u0003\u0002\u0002\u0002",
    "\u0015\u00c1\u0003\u0002\u0002\u0002\u0017\u00c3\u0003\u0002\u0002\u0002",
    "\u0019\u00c5\u0003\u0002\u0002\u0002\u001b\u00c7\u0003\u0002\u0002\u0002",
    "\u001d\u00c9\u0003\u0002\u0002\u0002\u001f\u00cb\u0003\u0002\u0002\u0002",
    "!\u00cd\u0003\u0002\u0002\u0002#\u00cf\u0003\u0002\u0002\u0002%\u00d1",
    "\u0003\u0002\u0002\u0002\'\u00d3\u0003\u0002\u0002\u0002)\u00d5\u0003",
    "\u0002\u0002\u0002+\u00d7\u0003\u0002\u0002\u0002-\u00d9\u0003\u0002",
    "\u0002\u0002/\u00db\u0003\u0002\u0002\u00021\u00dd\u0003\u0002\u0002",
    "\u00023\u00df\u0003\u0002\u0002\u00025\u00e1\u0003\u0002\u0002\u0002",
    "7\u00e3\u0003\u0002\u0002\u00029\u00e6\u0003\u0002\u0002\u0002;\u00eb",
    "\u0003\u0002\u0002\u0002=\u00f0\u0003\u0002\u0002\u0002?\u00f7\u0003",
    "\u0002\u0002\u0002A\u00fb\u0003\u0002\u0002\u0002C\u0100\u0003\u0002",
    "\u0002\u0002E\u0105\u0003\u0002\u0002\u0002G\u010a\u0003\u0002\u0002",
    "\u0002I\u0110\u0003\u0002\u0002\u0002K\u0115\u0003\u0002\u0002\u0002",
    "M\u0119\u0003\u0002\u0002\u0002O\u011c\u0003\u0002\u0002\u0002Q\u0120",
    "\u0003\u0002\u0002\u0002S\u0124\u0003\u0002\u0002\u0002U\u0129\u0003",
    "\u0002\u0002\u0002W\u0131\u0003\u0002\u0002\u0002Y\u013b\u0003\u0002",
    "\u0002\u0002[\u0141\u0003\u0002\u0002\u0002]\u0149\u0003\u0002\u0002",
    "\u0002_\u0151\u0003\u0002\u0002\u0002a\u015a\u0003\u0002\u0002\u0002",
    "c\u015c\u0003\u0002\u0002\u0002e\u0169\u0003\u0002\u0002\u0002g\u016c",
    "\u0003\u0002\u0002\u0002i\u0170\u0003\u0002\u0002\u0002k\u0178\u0003",
    "\u0002\u0002\u0002m\u0180\u0003\u0002\u0002\u0002o\u0183\u0003\u0002",
    "\u0002\u0002q\u0187\u0003\u0002\u0002\u0002s\u018d\u0003\u0002\u0002",
    "\u0002u\u018f\u0003\u0002\u0002\u0002w\u0192\u0003\u0002\u0002\u0002",
    "y\u0197\u0003\u0002\u0002\u0002{\u019c\u0003\u0002\u0002\u0002}\u019f",
    "\u0003\u0002\u0002\u0002\u007f\u01a3\u0003\u0002\u0002\u0002\u0081\u01a6",
    "\u0003\u0002\u0002\u0002\u0083\u01a9\u0003\u0002\u0002\u0002\u0085\u01b8",
    "\u0003\u0002\u0002\u0002\u0087\u01cd\u0003\u0002\u0002\u0002\u0089\u01cf",
    "\u0003\u0002\u0002\u0002\u008b\u01d1\u0003\u0002\u0002\u0002\u008d\u01d3",
    "\u0003\u0002\u0002\u0002\u008f\u01d5\u0003\u0002\u0002\u0002\u0091\u01d7",
    "\u0003\u0002\u0002\u0002\u0093\u01d9\u0003\u0002\u0002\u0002\u0095\u01db",
    "\u0003\u0002\u0002\u0002\u0097\u01dd\u0003\u0002\u0002\u0002\u0099\u01df",
    "\u0003\u0002\u0002\u0002\u009b\u01e1\u0003\u0002\u0002\u0002\u009d\u01e3",
    "\u0003\u0002\u0002\u0002\u009f\u01e5\u0003\u0002\u0002\u0002\u00a1\u01e7",
    "\u0003\u0002\u0002\u0002\u00a3\u01e9\u0003\u0002\u0002\u0002\u00a5\u01eb",
    "\u0003\u0002\u0002\u0002\u00a7\u01ee\u0003\u0002\u0002\u0002\u00a9\u01f4",
    "\u0003\u0002\u0002\u0002\u00ab\u01fa\u0003\u0002\u0002\u0002\u00ad\u01fd",
    "\u0003\u0002\u0002\u0002\u00af\u00b0\t\u0002\u0002\u0002\u00b0\u0004",
    "\u0003\u0002\u0002\u0002\u00b1\u00b2\t\u0003\u0002\u0002\u00b2\u0006",
    "\u0003\u0002\u0002\u0002\u00b3\u00b4\t\u0004\u0002\u0002\u00b4\b\u0003",
    "\u0002\u0002\u0002\u00b5\u00b6\t\u0005\u0002\u0002\u00b6\n\u0003\u0002",
    "\u0002\u0002\u00b7\u00b8\t\u0006\u0002\u0002\u00b8\f\u0003\u0002\u0002",
    "\u0002\u00b9\u00ba\t\u0007\u0002\u0002\u00ba\u000e\u0003\u0002\u0002",
    "\u0002\u00bb\u00bc\t\b\u0002\u0002\u00bc\u0010\u0003\u0002\u0002\u0002",
    "\u00bd\u00be\t\t\u0002\u0002\u00be\u0012\u0003\u0002\u0002\u0002\u00bf",
    "\u00c0\t\n\u0002\u0002\u00c0\u0014\u0003\u0002\u0002\u0002\u00c1\u00c2",
    "\t\u000b\u0002\u0002\u00c2\u0016\u0003\u0002\u0002\u0002\u00c3\u00c4",
    "\t\f\u0002\u0002\u00c4\u0018\u0003\u0002\u0002\u0002\u00c5\u00c6\t\r",
    "\u0002\u0002\u00c6\u001a\u0003\u0002\u0002\u0002\u00c7\u00c8\t\u000e",
    "\u0002\u0002\u00c8\u001c\u0003\u0002\u0002\u0002\u00c9\u00ca\t\u000f",
    "\u0002\u0002\u00ca\u001e\u0003\u0002\u0002\u0002\u00cb\u00cc\t\u0010",
    "\u0002\u0002\u00cc \u0003\u0002\u0002\u0002\u00cd\u00ce\t\u0011\u0002",
    "\u0002\u00ce\"\u0003\u0002\u0002\u0002\u00cf\u00d0\t\u0012\u0002\u0002",
    "\u00d0$\u0003\u0002\u0002\u0002\u00d1\u00d2\t\u0013\u0002\u0002\u00d2",
    "&\u0003\u0002\u0002\u0002\u00d3\u00d4\t\u0014\u0002\u0002\u00d4(\u0003",
    "\u0002\u0002\u0002\u00d5\u00d6\t\u0015\u0002\u0002\u00d6*\u0003\u0002",
    "\u0002\u0002\u00d7\u00d8\t\u0016\u0002\u0002\u00d8,\u0003\u0002\u0002",
    "\u0002\u00d9\u00da\t\u0017\u0002\u0002\u00da.\u0003\u0002\u0002\u0002",
    "\u00db\u00dc\t\u0018\u0002\u0002\u00dc0\u0003\u0002\u0002\u0002\u00dd",
    "\u00de\t\u0019\u0002\u0002\u00de2\u0003\u0002\u0002\u0002\u00df\u00e0",
    "\t\u001a\u0002\u0002\u00e04\u0003\u0002\u0002\u0002\u00e1\u00e2\t\u001b",
    "\u0002\u0002\u00e26\u0003\u0002\u0002\u0002\u00e3\u00e4\u0005\u0013",
    "\n\u0002\u00e4\u00e5\u0005\r\u0007\u0002\u00e58\u0003\u0002\u0002\u0002",
    "\u00e6\u00e7\u0005)\u0015\u0002\u00e7\u00e8\u0005\u0011\t\u0002\u00e8",
    "\u00e9\u0005\u000b\u0006\u0002\u00e9\u00ea\u0005\u001d\u000f\u0002\u00ea",
    ":\u0003\u0002\u0002\u0002\u00eb\u00ec\u0005\u000b\u0006\u0002\u00ec",
    "\u00ed\u0005\u0019\r\u0002\u00ed\u00ee\u0005\'\u0014\u0002\u00ee\u00ef",
    "\u0005\u000b\u0006\u0002\u00ef<\u0003\u0002\u0002\u0002\u00f0\u00f1",
    "\u0005\u000b\u0006\u0002\u00f1\u00f2\u0005\u0019\r\u0002\u00f2\u00f3",
    "\u0005\'\u0014\u0002\u00f3\u00f4\u0005\u000b\u0006\u0002\u00f4\u00f5",
    "\u0005\u0013\n\u0002\u00f5\u00f6\u0005\r\u0007\u0002\u00f6>\u0003\u0002",
    "\u0002\u0002\u00f7\u00f8\u0005\u000b\u0006\u0002\u00f8\u00f9\u0005\u001d",
    "\u000f\u0002\u00f9\u00fa\u0005\t\u0005\u0002\u00fa@\u0003\u0002\u0002",
    "\u0002\u00fb\u00fc\u0005\u0007\u0004\u0002\u00fc\u00fd\u0005\u0003\u0002",
    "\u0002\u00fd\u00fe\u0005\'\u0014\u0002\u00fe\u00ff\u0005\u000b\u0006",
    "\u0002\u00ffB\u0003\u0002\u0002\u0002\u0100\u0101\u0005/\u0018\u0002",
    "\u0101\u0102\u0005\u0011\t\u0002\u0102\u0103\u0005\u000b\u0006\u0002",
    "\u0103\u0104\u0005\u001d\u000f\u0002\u0104D\u0003\u0002\u0002\u0002",
    "\u0105\u0106\u0005)\u0015\u0002\u0106\u0107\u0005%\u0013\u0002\u0107",
    "\u0108\u0005+\u0016\u0002\u0108\u0109\u0005\u000b\u0006\u0002\u0109",
    "F\u0003\u0002\u0002\u0002\u010a\u010b\u0005\r\u0007\u0002\u010b\u010c",
    "\u0005\u0003\u0002\u0002\u010c\u010d\u0005\u0019\r\u0002\u010d\u010e",
    "\u0005\'\u0014\u0002\u010e\u010f\u0005\u000b\u0006\u0002\u010fH\u0003",
    "\u0002\u0002\u0002\u0110\u0111\u0005\u001d\u000f\u0002\u0111\u0112\u0005",
    "+\u0016\u0002\u0112\u0113\u0005\u0019\r\u0002\u0113\u0114\u0005\u0019",
    "\r\u0002\u0114J\u0003\u0002\u0002\u0002\u0115\u0116\u0005\u0003\u0002",
    "\u0002\u0116\u0117\u0005\u001d\u000f\u0002\u0117\u0118\u0005\t\u0005",
    "\u0002\u0118L\u0003\u0002\u0002\u0002\u0119\u011a\u0005\u001f\u0010",
    "\u0002\u011a\u011b\u0005%\u0013\u0002\u011bN\u0003\u0002\u0002\u0002",
    "\u011c\u011d\u0005\u001d\u000f\u0002\u011d\u011e\u0005\u001f\u0010\u0002",
    "\u011e\u011f\u0005)\u0015\u0002\u011fP\u0003\u0002\u0002\u0002\u0120",
    "\u0121\u0005\u0003\u0002\u0002\u0121\u0122\u0005\'\u0014\u0002\u0122",
    "\u0123\u0005\u0007\u0004\u0002\u0123R\u0003\u0002\u0002\u0002\u0124",
    "\u0125\u0005\t\u0005\u0002\u0125\u0126\u0005\u000b\u0006\u0002\u0126",
    "\u0127\u0005\'\u0014\u0002\u0127\u0128\u0005\u0007\u0004\u0002\u0128",
    "T\u0003\u0002\u0002\u0002\u0129\u012a\u0005\u001f\u0010\u0002\u012a",
    "\u012b\u0005%\u0013\u0002\u012b\u012c\u0005\t\u0005\u0002\u012c\u012d",
    "\u0005\u000b\u0006\u0002\u012d\u012e\u0005%\u0013\u0002\u012e\u012f",
    "\u0005\u0005\u0003\u0002\u012f\u0130\u00053\u001a\u0002\u0130V\u0003",
    "\u0002\u0002\u0002\u0131\u0132\u0005!\u0011\u0002\u0132\u0133\u0005",
    "\u0003\u0002\u0002\u0133\u0134\u0005%\u0013\u0002\u0134\u0135\u0005",
    ")\u0015\u0002\u0135\u0136\u0005\u0013\n\u0002\u0136\u0137\u0005)\u0015",
    "\u0002\u0137\u0138\u0005\u0013\n\u0002\u0138\u0139\u0005\u001f\u0010",
    "\u0002\u0139\u013a\u0005\u001d\u000f\u0002\u013aX\u0003\u0002\u0002",
    "\u0002\u013b\u013c\u0005\r\u0007\u0002\u013c\u013d\u0005\u0013\n\u0002",
    "\u013d\u013e\u00051\u0019\u0002\u013e\u013f\u0005\u000b\u0006\u0002",
    "\u013f\u0140\u0005\t\u0005\u0002\u0140Z\u0003\u0002\u0002\u0002\u0141",
    "\u0142\u0005\u0013\n\u0002\u0142\u0143\u0005\u001d\u000f\u0002\u0143",
    "\u0144\u0005\u0007\u0004\u0002\u0144\u0145\u0005\u0019\r\u0002\u0145",
    "\u0146\u0005+\u0016\u0002\u0146\u0147\u0005\t\u0005\u0002\u0147\u0148",
    "\u0005\u000b\u0006\u0002\u0148\\\u0003\u0002\u0002\u0002\u0149\u014a",
    "\u0005\u000b\u0006\u0002\u014a\u014b\u00051\u0019\u0002\u014b\u014c",
    "\u0005\u0007\u0004\u0002\u014c\u014d\u0005\u0019\r\u0002\u014d\u014e",
    "\u0005+\u0016\u0002\u014e\u014f\u0005\t\u0005\u0002\u014f\u0150\u0005",
    "\u000b\u0006\u0002\u0150^\u0003\u0002\u0002\u0002\u0151\u0152\u0007",
    "1\u0002\u0002\u0152\u0153\u00071\u0002\u0002\u0153\u0157\u0003\u0002",
    "\u0002\u0002\u0154\u0156\n\u001c\u0002\u0002\u0155\u0154\u0003\u0002",
    "\u0002\u0002\u0156\u0159\u0003\u0002\u0002\u0002\u0157\u0155\u0003\u0002",
    "\u0002\u0002\u0157\u0158\u0003\u0002\u0002\u0002\u0158`\u0003\u0002",
    "\u0002\u0002\u0159\u0157\u0003\u0002\u0002\u0002\u015a\u015b\t\u001d",
    "\u0002\u0002\u015bb\u0003\u0002\u0002\u0002\u015c\u0161\u0005a1\u0002",
    "\u015d\u0160\u0005a1\u0002\u015e\u0160\u0005\u0081A\u0002\u015f\u015d",
    "\u0003\u0002\u0002\u0002\u015f\u015e\u0003\u0002\u0002\u0002\u0160\u0163",
    "\u0003\u0002\u0002\u0002\u0161\u015f\u0003\u0002\u0002\u0002\u0161\u0162",
    "\u0003\u0002\u0002\u0002\u0162d\u0003\u0002\u0002\u0002\u0163\u0161",
    "\u0003\u0002\u0002\u0002\u0164\u0168\n\u001e\u0002\u0002\u0165\u0166",
    "\u0007_\u0002\u0002\u0166\u0168\u0007_\u0002\u0002\u0167\u0164\u0003",
    "\u0002\u0002\u0002\u0167\u0165\u0003\u0002\u0002\u0002\u0168\u016b\u0003",
    "\u0002\u0002\u0002\u0169\u0167\u0003\u0002\u0002\u0002\u0169\u016a\u0003",
    "\u0002\u0002\u0002\u016af\u0003\u0002\u0002\u0002\u016b\u0169\u0003",
    "\u0002\u0002\u0002\u016c\u016d\u0007]\u0002\u0002\u016d\u016e\u0005",
    "e3\u0002\u016e\u016f\u0007_\u0002\u0002\u016fh\u0003\u0002\u0002\u0002",
    "\u0170\u0171\u0007]\u0002\u0002\u0171\u0172\u0005e3\u0002\u0172j\u0003",
    "\u0002\u0002\u0002\u0173\u0177\n\u001f\u0002\u0002\u0174\u0175\u0007",
    "$\u0002\u0002\u0175\u0177\u0007$\u0002\u0002\u0176\u0173\u0003\u0002",
    "\u0002\u0002\u0176\u0174\u0003\u0002\u0002\u0002\u0177\u017a\u0003\u0002",
    "\u0002\u0002\u0178\u0176\u0003\u0002\u0002\u0002\u0178\u0179\u0003\u0002",
    "\u0002\u0002\u0179l\u0003\u0002\u0002\u0002\u017a\u0178\u0003\u0002",
    "\u0002\u0002\u017b\u017f\n \u0002\u0002\u017c\u017d\u0007)\u0002\u0002",
    "\u017d\u017f\u0007)\u0002\u0002\u017e\u017b\u0003\u0002\u0002\u0002",
    "\u017e\u017c\u0003\u0002\u0002\u0002\u017f\u0182\u0003\u0002\u0002\u0002",
    "\u0180\u017e\u0003\u0002\u0002\u0002\u0180\u0181\u0003\u0002\u0002\u0002",
    "\u0181n\u0003\u0002\u0002\u0002\u0182\u0180\u0003\u0002\u0002\u0002",
    "\u0183\u0184\u0007$\u0002\u0002\u0184\u0185\u0005k6\u0002\u0185\u0186",
    "\u0007$\u0002\u0002\u0186p\u0003\u0002\u0002\u0002\u0187\u0188\u0007",
    ")\u0002\u0002\u0188\u0189\u0005m7\u0002\u0189\u018a\u0007)\u0002\u0002",
    "\u018ar\u0003\u0002\u0002\u0002\u018b\u018e\u0005o8\u0002\u018c\u018e",
    "\u0005q9\u0002\u018d\u018b\u0003\u0002\u0002\u0002\u018d\u018c\u0003",
    "\u0002\u0002\u0002\u018et\u0003\u0002\u0002\u0002\u018f\u0190\u0007",
    "$\u0002\u0002\u0190\u0191\u0005k6\u0002\u0191v\u0003\u0002\u0002\u0002",
    "\u0192\u0193\u0007)\u0002\u0002\u0193\u0194\u0005m7\u0002\u0194x\u0003",
    "\u0002\u0002\u0002\u0195\u0198\u0005u;\u0002\u0196\u0198\u0005w<\u0002",
    "\u0197\u0195\u0003\u0002\u0002\u0002\u0197\u0196\u0003\u0002\u0002\u0002",
    "\u0198z\u0003\u0002\u0002\u0002\u0199\u019b\n!\u0002\u0002\u019a\u0199",
    "\u0003\u0002\u0002\u0002\u019b\u019e\u0003\u0002\u0002\u0002\u019c\u019a",
    "\u0003\u0002\u0002\u0002\u019c\u019d\u0003\u0002\u0002\u0002\u019d|",
    "\u0003\u0002\u0002\u0002\u019e\u019c\u0003\u0002\u0002\u0002\u019f\u01a0",
    "\u0007%\u0002\u0002\u01a0\u01a1\u0005{>\u0002\u01a1\u01a2\u0007%\u0002",
    "\u0002\u01a2~\u0003\u0002\u0002\u0002\u01a3\u01a4\u0007%\u0002\u0002",
    "\u01a4\u01a5\u0005{>\u0002\u01a5\u0080\u0003\u0002\u0002\u0002\u01a6",
    "\u01a7\u00042;\u0002\u01a7\u0082\u0003\u0002\u0002\u0002\u01a8\u01aa",
    "\u0005\u0081A\u0002\u01a9\u01a8\u0003\u0002\u0002\u0002\u01aa\u01ab",
    "\u0003\u0002\u0002\u0002\u01ab\u01a9\u0003\u0002\u0002\u0002\u01ab\u01ac",
    "\u0003\u0002\u0002\u0002\u01ac\u01b3\u0003\u0002\u0002\u0002\u01ad\u01af",
    "\u0005\u000b\u0006\u0002\u01ae\u01b0\u0005\u0081A\u0002\u01af\u01ae",
    "\u0003\u0002\u0002\u0002\u01b0\u01b1\u0003\u0002\u0002\u0002\u01b1\u01af",
    "\u0003\u0002\u0002\u0002\u01b1\u01b2\u0003\u0002\u0002\u0002\u01b2\u01b4",
    "\u0003\u0002\u0002\u0002\u01b3\u01ad\u0003\u0002\u0002\u0002\u01b3\u01b4",
    "\u0003\u0002\u0002\u0002\u01b4\u0084\u0003\u0002\u0002\u0002\u01b5\u01b7",
    "\u0005\u0081A\u0002\u01b6\u01b5\u0003\u0002\u0002\u0002\u01b7\u01ba",
    "\u0003\u0002\u0002\u0002\u01b8\u01b6\u0003\u0002\u0002\u0002\u01b8\u01b9",
    "\u0003\u0002\u0002\u0002\u01b9\u01bb\u0003\u0002\u0002\u0002\u01ba\u01b8",
    "\u0003\u0002\u0002\u0002\u01bb\u01bd\u00070\u0002\u0002\u01bc\u01be",
    "\u0005\u0081A\u0002\u01bd\u01bc\u0003\u0002\u0002\u0002\u01be\u01bf",
    "\u0003\u0002\u0002\u0002\u01bf\u01bd\u0003\u0002\u0002\u0002\u01bf\u01c0",
    "\u0003\u0002\u0002\u0002\u01c0\u01cb\u0003\u0002\u0002\u0002\u01c1\u01c4",
    "\u0005\u000b\u0006\u0002\u01c2\u01c5\u0005\u0095K\u0002\u01c3\u01c5",
    "\u0005\u0097L\u0002\u01c4\u01c2\u0003\u0002\u0002\u0002\u01c4\u01c3",
    "\u0003\u0002\u0002\u0002\u01c4\u01c5\u0003\u0002\u0002\u0002\u01c5\u01c7",
    "\u0003\u0002\u0002\u0002\u01c6\u01c8\u0005\u0081A\u0002\u01c7\u01c6",
    "\u0003\u0002\u0002\u0002\u01c8\u01c9\u0003\u0002\u0002\u0002\u01c9\u01c7",
    "\u0003\u0002\u0002\u0002\u01c9\u01ca\u0003\u0002\u0002\u0002\u01ca\u01cc",
    "\u0003\u0002\u0002\u0002\u01cb\u01c1\u0003\u0002\u0002\u0002\u01cb\u01cc",
    "\u0003\u0002\u0002\u0002\u01cc\u0086\u0003\u0002\u0002\u0002\u01cd\u01ce",
    "\u0007_\u0002\u0002\u01ce\u0088\u0003\u0002\u0002\u0002\u01cf\u01d0",
    "\u0007}\u0002\u0002\u01d0\u008a\u0003\u0002\u0002\u0002\u01d1\u01d2",
    "\u0007\u007f\u0002\u0002\u01d2\u008c\u0003\u0002\u0002\u0002\u01d3\u01d4",
    "\u0007*\u0002\u0002\u01d4\u008e\u0003\u0002\u0002\u0002\u01d5\u01d6",
    "\u0007+\u0002\u0002\u01d6\u0090\u0003\u0002\u0002\u0002\u01d7\u01d8",
    "\u0007.\u0002\u0002\u01d8\u0092\u0003\u0002\u0002\u0002\u01d9\u01da",
    "\u0007<\u0002\u0002\u01da\u0094\u0003\u0002\u0002\u0002\u01db\u01dc",
    "\u0007-\u0002\u0002\u01dc\u0096\u0003\u0002\u0002\u0002\u01dd\u01de",
    "\u0007/\u0002\u0002\u01de\u0098\u0003\u0002\u0002\u0002\u01df\u01e0",
    "\u00071\u0002\u0002\u01e0\u009a\u0003\u0002\u0002\u0002\u01e1\u01e2",
    "\u0007,\u0002\u0002\u01e2\u009c\u0003\u0002\u0002\u0002\u01e3\u01e4",
    "\u0007\'\u0002\u0002\u01e4\u009e\u0003\u0002\u0002\u0002\u01e5\u01e6",
    "\u0007`\u0002\u0002\u01e6\u00a0\u0003\u0002\u0002\u0002\u01e7\u01e8",
    "\u0007@\u0002\u0002\u01e8\u00a2\u0003\u0002\u0002\u0002\u01e9\u01ea",
    "\u0007>\u0002\u0002\u01ea\u00a4\u0003\u0002\u0002\u0002\u01eb\u01ec",
    "\u0007@\u0002\u0002\u01ec\u01ed\u0007?\u0002\u0002\u01ed\u00a6\u0003",
    "\u0002\u0002\u0002\u01ee\u01ef\u0007>\u0002\u0002\u01ef\u01f0\u0007",
    "?\u0002\u0002\u01f0\u00a8\u0003\u0002\u0002\u0002\u01f1\u01f2\u0007",
    "?\u0002\u0002\u01f2\u01f5\u0007?\u0002\u0002\u01f3\u01f5\u0007?\u0002",
    "\u0002\u01f4\u01f1\u0003\u0002\u0002\u0002\u01f4\u01f3\u0003\u0002\u0002",
    "\u0002\u01f5\u00aa\u0003\u0002\u0002\u0002\u01f6\u01f7\u0007#\u0002",
    "\u0002\u01f7\u01fb\u0007?\u0002\u0002\u01f8\u01f9\u0007>\u0002\u0002",
    "\u01f9\u01fb\u0007@\u0002\u0002\u01fa\u01f6\u0003\u0002\u0002\u0002",
    "\u01fa\u01f8\u0003\u0002\u0002\u0002\u01fb\u00ac\u0003\u0002\u0002\u0002",
    "\u01fc\u01fe\t\"\u0002\u0002\u01fd\u01fc\u0003\u0002\u0002\u0002\u01fe",
    "\u01ff\u0003\u0002\u0002\u0002\u01ff\u01fd\u0003\u0002\u0002\u0002\u01ff",
    "\u0200\u0003\u0002\u0002\u0002\u0200\u0201\u0003\u0002\u0002\u0002\u0201",
    "\u0202\bW\u0002\u0002\u0202\u00ae\u0003\u0002\u0002\u0002\u001a\u0002",
    "\u0157\u015f\u0161\u0167\u0169\u0176\u0178\u017e\u0180\u018d\u0197\u019c",
    "\u01ab\u01b1\u01b3\u01b8\u01bf\u01c4\u01c9\u01cb\u01f4\u01fa\u01ff\u0003",
    "\u0002\u0003\u0002"].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

function TableauExpressionLexer(input) {
	antlr4.Lexer.call(this, input);
    this._interp = new antlr4.atn.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.PredictionContextCache());
    return this;
}

TableauExpressionLexer.prototype = Object.create(antlr4.Lexer.prototype);
TableauExpressionLexer.prototype.constructor = TableauExpressionLexer;

Object.defineProperty(TableauExpressionLexer.prototype, "atn", {
        get : function() {
                return atn;
        }
});

TableauExpressionLexer.EOF = antlr4.Token.EOF;
TableauExpressionLexer.IF = 1;
TableauExpressionLexer.THEN = 2;
TableauExpressionLexer.ELSE = 3;
TableauExpressionLexer.ELSEIF = 4;
TableauExpressionLexer.END = 5;
TableauExpressionLexer.CASE = 6;
TableauExpressionLexer.WHEN = 7;
TableauExpressionLexer.TRUE = 8;
TableauExpressionLexer.FALSE = 9;
TableauExpressionLexer.NULL = 10;
TableauExpressionLexer.AND = 11;
TableauExpressionLexer.OR = 12;
TableauExpressionLexer.NOT = 13;
TableauExpressionLexer.ASC = 14;
TableauExpressionLexer.DESC = 15;
TableauExpressionLexer.ORDERBY = 16;
TableauExpressionLexer.PARTITION = 17;
TableauExpressionLexer.FIXED = 18;
TableauExpressionLexer.INCLUDE = 19;
TableauExpressionLexer.EXCLUDE = 20;
TableauExpressionLexer.COMMENT = 21;
TableauExpressionLexer.IDENTIFIER = 22;
TableauExpressionLexer.FIELDNAME = 23;
TableauExpressionLexer.FIELDNAME_INCOMPLETE = 24;
TableauExpressionLexer.STRINGLITERAL = 25;
TableauExpressionLexer.STRINGLITERAL_INCOMPLETE = 26;
TableauExpressionLexer.DATELITERAL = 27;
TableauExpressionLexer.DATELITERAL_INCOMPLETE = 28;
TableauExpressionLexer.INTEGER = 29;
TableauExpressionLexer.FLOAT = 30;
TableauExpressionLexer.RBRACKET = 31;
TableauExpressionLexer.LCBRACK = 32;
TableauExpressionLexer.RCBRACK = 33;
TableauExpressionLexer.LPAREN = 34;
TableauExpressionLexer.RPAREN = 35;
TableauExpressionLexer.COMMA = 36;
TableauExpressionLexer.COLON = 37;
TableauExpressionLexer.PLUS = 38;
TableauExpressionLexer.MINUS = 39;
TableauExpressionLexer.DIVIDE = 40;
TableauExpressionLexer.MULTIPLY = 41;
TableauExpressionLexer.MOD = 42;
TableauExpressionLexer.EXPONENT = 43;
TableauExpressionLexer.GT = 44;
TableauExpressionLexer.LT = 45;
TableauExpressionLexer.GTE = 46;
TableauExpressionLexer.LTE = 47;
TableauExpressionLexer.EQ = 48;
TableauExpressionLexer.NEQ = 49;
TableauExpressionLexer.WHITESPACE = 50;

TableauExpressionLexer.prototype.channelNames = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];

TableauExpressionLexer.prototype.modeNames = [ "DEFAULT_MODE" ];

TableauExpressionLexer.prototype.literalNames = [ null, null, null, null, 
                                                  null, null, null, null, 
                                                  null, null, null, null, 
                                                  null, null, null, null, 
                                                  null, null, null, null, 
                                                  null, null, null, null, 
                                                  null, null, null, null, 
                                                  null, null, null, "']'", 
                                                  "'{'", "'}'", "'('", "')'", 
                                                  "','", "':'", "'+'", "'-'", 
                                                  "'/'", "'*'", "'%'", "'^'", 
                                                  "'>'", "'<'", "'>='", 
                                                  "'<='" ];

TableauExpressionLexer.prototype.symbolicNames = [ null, "IF", "THEN", "ELSE", 
                                                   "ELSEIF", "END", "CASE", 
                                                   "WHEN", "TRUE", "FALSE", 
                                                   "NULL", "AND", "OR", 
                                                   "NOT", "ASC", "DESC", 
                                                   "ORDERBY", "PARTITION", 
                                                   "FIXED", "INCLUDE", "EXCLUDE", 
                                                   "COMMENT", "IDENTIFIER", 
                                                   "FIELDNAME", "FIELDNAME_INCOMPLETE", 
                                                   "STRINGLITERAL", "STRINGLITERAL_INCOMPLETE", 
                                                   "DATELITERAL", "DATELITERAL_INCOMPLETE", 
                                                   "INTEGER", "FLOAT", "RBRACKET", 
                                                   "LCBRACK", "RCBRACK", 
                                                   "LPAREN", "RPAREN", "COMMA", 
                                                   "COLON", "PLUS", "MINUS", 
                                                   "DIVIDE", "MULTIPLY", 
                                                   "MOD", "EXPONENT", "GT", 
                                                   "LT", "GTE", "LTE", "EQ", 
                                                   "NEQ", "WHITESPACE" ];

TableauExpressionLexer.prototype.ruleNames = [ "A", "B", "C", "D", "E", 
                                               "F", "G", "H", "I", "J", 
                                               "K", "L", "M", "N", "O", 
                                               "P", "Q", "R", "S", "T", 
                                               "U", "V", "W", "X", "Y", 
                                               "Z", "IF", "THEN", "ELSE", 
                                               "ELSEIF", "END", "CASE", 
                                               "WHEN", "TRUE", "FALSE", 
                                               "NULL", "AND", "OR", "NOT", 
                                               "ASC", "DESC", "ORDERBY", 
                                               "PARTITION", "FIXED", "INCLUDE", 
                                               "EXCLUDE", "COMMENT", "IDENTIFIER_NONDIGIT", 
                                               "IDENTIFIER", "FIELDNAME_BODY_IN_BRACKETS", 
                                               "FIELDNAME", "FIELDNAME_INCOMPLETE", 
                                               "STRINGLITERAL_BODY_IN_DOUBLE_QUOTES", 
                                               "STRINGLITERAL_BODY_IN_SINGLE_QUOTES", 
                                               "STRINGLITERAL_IN_DOUBLE_QUOTES", 
                                               "STRINGLITERAL_IN_SINGLE_QUOTES", 
                                               "STRINGLITERAL", "STRINGLITERAL_INCOMPLETE_IN_DOUBLE_QUOTES", 
                                               "STRINGLITERAL_INCOMPLETE_IN_SINGLE_QUOTES", 
                                               "STRINGLITERAL_INCOMPLETE", 
                                               "DATELITERAL_BODY", "DATELITERAL", 
                                               "DATELITERAL_INCOMPLETE", 
                                               "DIGIT", "INTEGER", "FLOAT", 
                                               "RBRACKET", "LCBRACK", "RCBRACK", 
                                               "LPAREN", "RPAREN", "COMMA", 
                                               "COLON", "PLUS", "MINUS", 
                                               "DIVIDE", "MULTIPLY", "MOD", 
                                               "EXPONENT", "GT", "LT", "GTE", 
                                               "LTE", "EQ", "NEQ", "WHITESPACE" ];

TableauExpressionLexer.prototype.grammarFileName = "TableauExpression.g4";



exports.TableauExpressionLexer = TableauExpressionLexer;

